import {
  InitOverrideFunction,
  WhitelabelApi,
  WhitelabelGetTranslationsRequest,
  WhitelabelResetSettingToDefaultPutRequest,
  WhitelabelSettingReadModel,
  WhitelabelUpdateLogoPutRequest,
  WhitelabelUpdateSettingPutRequest,
} from "../../../@api";

export class WhitelabelApiService
  implements Omit<WhitelabelApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: WhitelabelApi) {}

  public async whitelabelGetSettings(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Array<WhitelabelSettingReadModel>> {
    return this.api.whitelabelGetSettings(initOverrides);
  }

  public async whitelabelGetLogo(initOverrides?: RequestInit | InitOverrideFunction): Promise<Blob> {
    return this.api.whitelabelGetLogo(initOverrides);
  }

  public async whitelabelGetTranslations(
    requestParameters: WhitelabelGetTranslationsRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Blob> {
    return this.api.whitelabelGetTranslations(requestParameters, initOverrides);
  }

  public async whitelabelUpdateSettingPut(
    requestParameters?: WhitelabelUpdateSettingPutRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.whitelabelUpdateSettingPut(requestParameters, initOverrides);
  }

  public async whitelabelUpdateLogoPut(
    requestParameters?: WhitelabelUpdateLogoPutRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.whitelabelUpdateLogoPut(requestParameters, initOverrides);
  }

  public async whitelabelResetAllSettingsToDefaultPut(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.whitelabelResetAllSettingsToDefaultPut(initOverrides);
  }

  public async whitelabelResetSettingToDefaultPut(
    requestParameters: WhitelabelResetSettingToDefaultPutRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<void> {
    return this.api.whitelabelResetSettingToDefaultPut(requestParameters, initOverrides);
  }
}
